import React from "react";

const RaInput = ({ children, ...props }) => (
	<div className="ra-input">{children}</div>
);

export default RaInput;
